import React from 'react';
import createSVG from './createSVG';

const ReplaceIcon = ({style}) => (
  <path style={style} fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="1.71" d="M1.043 4.4526L3.9235 1M1.043 4.4526l2.8804 3.4527M1 21.5473V8.068m0 13.4794h24m0-17.0948V17.932m0-13.4794H1.2402M25 21.5474L22.1206 25M25 21.5474l-2.8794-3.4527" strokeLinecap="round" strokeLinejoin="round"/>
);

export default createSVG(ReplaceIcon);
